import { NewMakerCvObjActionF } from '../../../NewMaker/CvObjAction/F/Function/module/NewMakerCvObjActionF.js';

export const stickerMaskingTapeBpOptionInit = async () => {
  const selected_option_group = box().maker.product_color._.selected_option_group;
  if (!selected_option_group?.bp_option_ids?.length) return;
  await NewMakerCvObjActionF.render({ bp_option_ids: selected_option_group.bp_option_ids });
};
